import { type AppointmentModuleSpecsFragment } from '../../../../api/fragments/AppointmentModuleSpecs';
import AppointmentModuleDetails from './AppointmentModuleDetails';
import AppointmentModuleEmail from './AppointmentModuleEmail';
import { HeaderTabs } from './shared';

export type AppointmentModuleDetailsInnerProps = {
    module: AppointmentModuleSpecsFragment;
    activeTab: HeaderTabs;
};

const AppointmentModuleDetailsInner = ({ module, activeTab }: AppointmentModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return <AppointmentModuleDetails module={module} />;

        case HeaderTabs.Email:
            return <AppointmentModuleEmail module={module} />;

        default:
            throw new Error('HeaderTabs not support');
    }
};

export default AppointmentModuleDetailsInner;
